/* TileGrid — the register tiles on the shell's grid (13-15). */

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
  align-items: stretch;
}

/* Each grid cell stretches its tile to equal height. */
.grid > [role='listitem'] {
  display: flex;
}

.grid > [role='listitem'] > * {
  width: 100%;
}

/* Emphasised tiles (a role's lead registers): a sage ring, a presentation cue only, never a
 * purple fill (04-CONTEXT.md §5). */
.emphasised > * {
  border-color: var(--sage-dark);
  box-shadow: var(--shadow-md), 0 0 0 1px var(--sage-dark);
}
